import weChatConfig from './message/weChatConfig'

import {defineI18nCreate} from "@verdure/core";

export default defineI18nCreate([
    weChatConfig
])
